import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upgrade",
  "use": "icon-upgrade-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1000 1000\" id=\"icon-upgrade\">\r\n<metadata> Svg Vector Icons : http://www.sfont.cn </metadata>\r\n<g><path d=\"M500,10C229.4,10,10,229.4,10,500c0,270.6,219.4,490,490,490c270.6,0,490-219.4,490-490C990,229.4,770.6,10,500,10z M576.6,419.7V768H423.4V419.7H312.3l111.1-111.1L500,232l76.6,76.6l111.1,111.1H576.6z\" /></g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol